import { z } from 'zod';

export const AvgTransportSpeedSchema = z.object({
  id: z.string().or(z.number()),
  name: z
    .string()
    .min(1, 'Название обязательно для заполнения')
    .max(200, 'Название не должно превышать 200 символов'),
  description: z
    .string()
    .max(300, 'Описание не должно превышать 300 символов')
    .optional()
    .or(z.literal('')),
  value:     z
    .number({
      required_error: 'Средняя скорость обязательна для заполнения',
      invalid_type_error: 'Поле обязательно для заполнения'
    })
    .min(0, 'Средняя скорость не может быть меньше 0')
    .max(300, 'Средняя скорость не может превышать 300 км/ч'),
  roadCurvature:     z
    .number({
      required_error: 'Коэффициент кривизны дороги обязателен для заполнения',
      invalid_type_error: 'Поле обязательно для заполнения'
    })
    .min(0.1, 'Коэффициент кривизны дороги должен быть не меньше 0.1')
    .max(2.0, 'Коэффициент кривизны дороги должен быть не больше 2.0')
});
